import { render, staticRenderFns } from "./DoubleLogo.vue?vue&type=template&id=a03441d0"
import script from "./DoubleLogo.vue?vue&type=script&lang=js"
export * from "./DoubleLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports